<template>
  <div class="income-statement-view">
    <div class="section operations" style="margin-bottom:1px;">
      <el-form inline style="margin-bottom:-12px;">
        <!--会计期间-->
        <el-form-item :label="$t('CargoMsg.Cargo_FiscalPeriod')">
          <el-select v-if="reportType==='month'" ref="fromFPRef" v-model="fpUuid" style="width: 120px;" no="1">
            <el-option
              v-for="(item,index) in fiscalPeriods"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
          <el-select v-if="reportType==='quarter'" ref="fromFPRef" v-model="fpUuid" style="width: 120px;" no="2">
            <el-option
              v-for="(item,index) in Quarters"
              :key="index"
              :label="quarterLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
          <el-select v-if="reportType==='year'" ref="fromFPRef" v-model="fpUuid" style="width: 120px;" no="3">
            <el-option
              v-for="(item,index) in Years"
              :key="index"
              :label="yearLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <!--查询-->
          <el-button class="el-margin" type="primary" no="4" @click="doSearch">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <!--导出明细-->
          <el-button :disabled="!(rowData && rowData.length > 0)" type="primary" no="5" @click="exportHandler">{{ this.$t('ChangeCharge.exportDetail') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="flex: 1;padding: 0px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :grid-params.sync="girdParams"
        :auto-fit-content="false"
        :row-data="rowData"
        style="height: 800px;"
      />
    </div>
    <element-formula-edit-dialog
      :visible="elementFormulaEditDialog.visible"
      :atb-dictionary="atbDictionary"
      :elementformula-editable="elementFormulaEditDialog.elementformulaEditable"
      :statement-element-description-uuid="elementFormulaEditDialog.statementElementDescriptionUuid"
      :statement-element-description="elementFormulaEditDialog.statementElementDescription"
      statement-name="BalanceSheetStatement"
      :fiscal-period="elementFormulaEditDialog.fiscalPeriod"
      :account-set="accountSet"
      @close="elementFormulaEditDialog.visible=false"
    />
  </div>
</template>

<script>
import * as statementDescriptionApi from '@/api/financeManage/statementDescription'
import { getLoading } from '@/utils/utilBaseElement'
import * as NumberUtils from '@/utils/NumberUtils'
import { DocumentManage } from '@/utils/commonUtil'
import ElementFormulaEditDialog from '@/views/cargo/v0/FinanceManage/FinancialReport/components/ElementFormulaEditDialog'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { chineseToEnglish } from './BalanceSheetStatementLanguage.js'

export default {
  name: 'BalanceSheetStatement',
  components: { ElementFormulaEditDialog },
  props: {
    accountSet: { type: Object, default: null },
    reportType: { type: String, default: 'month' } // month、quarter、year
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: false,
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        }
      },
      columns: [
        { headerName: this.$t('CargoMsg.Cargo_Assets'), width: 290 },
        { headerName: this.$t('CargoMsg.Cargo_LineNo'), width: 80 },
        { headerName: this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear'), width: 180 },
        { headerName: this.$t('CargoMsg.Cargo_PeriodEndAmount'), width: 180 },
        { headerName: this.$t('CargoMsg.Cargo_LiabilitiesOwner'), width: 290 },
        { headerName: this.$t('CargoMsg.Cargo_LineNo'), width: 80 },
        { headerName: this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear'), width: 180 },
        { headerName: this.$t('CargoMsg.Cargo_PeriodEndAmount'), width: 180 }
      ],
      rowData: [],
      fpUuid: '',
      atbDictionary: {},
      elementFormulaEditDialog: {
        visible: false,
        elementformulaEditable: false,
        statementElementDescriptionUuid: '',
        statementElementDescription: {},
        fiscalPeriod: {}
      },
      excelColumnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_Assets'), field: 'field00', width: 290 },
        { headerName: this.$t('CargoMsg.Cargo_LineNo'), field: 'field01', width: 80 },
        { headerName: this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear'), field: 'field02', width: 180,
          cellRenderer: params => { return params.value ? params.value : '' }
        },
        { headerName: this.$t('CargoMsg.Cargo_PeriodEndAmount'), field: 'field03', width: 180,
          cellRenderer: params => { return params.value ? params.value : '' }
        },
        { headerName: this.$t('CargoMsg.Cargo_LiabilitiesOwner'), field: 'field10', width: 290 },
        { headerName: this.$t('CargoMsg.Cargo_LineNo2'), field: 'field11', width: 80 },
        { headerName: this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear2'), field: 'field12', width: 180,
          cellRenderer: params => { return params.value ? params.value : '' }
        },
        { headerName: this.$t('CargoMsg.Cargo_PeriodEndAmount2'), field: 'field13', width: 180,
          cellRenderer: params => { return params.value ? params.value : '' }
        }
      ]
    }
  },
  computed: {
    // 当前会计期间
    currentFiscalPeriod() {
      return this.accountSet ? this.accountSet.currentFiscalPeriod : null
    },
    // 初始会计期间
    initialFiscalPeriod() {
      return this.accountSet ? this.accountSet.initialFiscalPeriod : null
    },
    // 会计期间
    fiscalPeriods() {
      return this.accountSet ? this.accountSet.fiscalPeriod : []
    },
    fiscalPeriod() {
      if (this.fiscalPeriods && this.fpUuid) {
        return this.fiscalPeriods.find(fp => fp.uuid === this.fpUuid)
      }
      return null
    },
    columnDefs() {
      return this.columns
    },
    elementFormulaEditable() {
      if (!this.currentFiscalPeriod || !this.initialFiscalPeriod) {
        return false
      }
      if (this.currentFiscalPeriod.year === this.initialFiscalPeriod.year &&
        this.currentFiscalPeriod.month === this.initialFiscalPeriod.month) {
        return true
      }
      if (this.currentFiscalPeriod.year !== this.initialFiscalPeriod.year && this.currentFiscalPeriod.month === 1) {
        return true
      }
      return false
    },
    Quarters() {
      return this.accountSet ? this.accountSet.Quarters : []
    },
    Years() {
      return this.accountSet ? this.accountSet.Years : []
    }
  },
  watch: {
    accountSet(newVal) {
      if (newVal) {
        // this.fpUuid = this.fiscalPeriods ? this.fiscalPeriods[0].uuid : ''
      }
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('statementColumnDescriptionClickHandler', function(data) {
      self.statementColumnDescriptionClickHandler(data)
    })
  },
  methods: {
    fiscalPeriodLabelFun(data) {
      if (data) {
        return this.$t('FinanceManage.IssueMonthOfYear', [data.year, data.month])
      }
      return ''
    },
    doSearch() {
      const params = {}
      params.accountSetKey = this.accountSet.uuid
      params.statementName = 'BalanceSheetStatement'
      if (!this.fiscalPeriod) {
        return
      }
      params.fiscalPeriod = this.fiscalPeriod.uuid
      params.year = this.fiscalPeriod.year
      params.month = this.fiscalPeriod.month
      params.reportType = this.reportType
      const loading = getLoading()
      statementDescriptionApi.getStatement2(params).then(resp => {
        this.getStatementResult(resp)
      }).finally(() => loading.close())
    },
    getStatementResult(resp) {
      const result = resp.data
      chineseToEnglish(result)
      if (result && result.atbs && result.atbs instanceof Array) {
        for (const atb of result.atbs) {
          this.atbDictionary[atb.accountTitle] = atb
        }
      }
      if (result && result.columns && result.dataProvider) {
        const columns = []
        for (const columnDescription of result.columns) {
          const column = {}
          this.setColumn(columnDescription, column)
          column.columnNo = columnDescription.columnNo
          column.groupNo = columnDescription.groupNo
          column.headerName = columnDescription.name
          column.field = 'field' + columnDescription.groupNo + columnDescription.columnNo
          columns.push(column)
        }
        const columnGroupNo0 = columns.filter(column => column.groupNo === 0).sort((column1, column2) => column1.columnNo > column2.columnNo ? 1 : -1)
        const columnGroupNo1 = columns.filter(column => column.groupNo === 1).sort((column1, column2) => column1.columnNo > column2.columnNo ? 1 : -1)

        this.columns = [...columnGroupNo0, ...columnGroupNo1]

        this.rowData = result.dataProvider
      }
    },
    setColumn(columnDescription, column) {
      if (columnDescription.columnNo === 0) {
        column.cellRenderer = this.statementColumnDescriptionItemRender
        column.width = 290
      }
      if (columnDescription.columnNo === 1) {
        column.width = 80
        column.cellStyle = { textAlign: 'center' }
      }
      if (columnDescription.columnNo === 2 || columnDescription.columnNo === 3) {
        column.cellRenderer = this.amountLabelItemRenderer
        column.width = 180
        column.cellStyle = { textAlign: 'right' }
      }
    },
    statementColumnDescriptionItemRender(params) {
      if (!params.data['data' + params.colDef.groupNo]) return ''
      if (!params.data['data' + params.colDef.groupNo].calculatedItem) return params.value
      const methodPath = this.documentManage.getPath('statementColumnDescriptionClickHandler')
      let spaceCount = params.value.length - params.value.trim().length
      let space = ``
      while (spaceCount > 0) {
        space += `&nbsp;`
        spaceCount--
      }
      return space + `<a onclick="${methodPath}('${params.rowIndex}' + '@' + '${params.colDef.groupNo}')" style="text-decoration: underline;">${params.value}</a>`
    },
    amountLabelItemRenderer(params) {
      if (params.value) {
        return NumberUtils.formatRoundNumber(params.value, 2)
      }
      return ''
    },
    statementColumnDescriptionClickHandler(value) {
      const arr = value.split('@')
      const rowIndex = arr[0]
      const groupNo = arr[1]
      const row = this.rowData[rowIndex]
      this.elementFormulaEditDialog.accountSet = this.accountSet
      this.elementFormulaEditDialog.fiscalPeriod = this.fiscalPeriod
      this.elementFormulaEditDialog.statementElementDescriptionUuid = row['data' + groupNo].uuid
      this.elementFormulaEditDialog.statementElementDescription = row['data' + groupNo]
      this.elementFormulaEditDialog.elementformulaEditable = this.elementFormulaEditable
      this.elementFormulaEditDialog.visible = true
    },
    calculateCount(value) {
      const FIELD_DEFINE = 'field'
      // 流动资产合计(0,15) =货币资金(0,1)+短期投资(0,2)+应收票据(0,3)+应收账款(0,4)+预付账款(0,5)
      // +应收股利(0,6)+应收利息(0,7)+其他应收款(0,8)+存货(0,9)+其他流动资产(0,14)
      this.getItem(0, 15, value)[FIELD_DEFINE + '02'] = this.getItem(0, 1, value)[FIELD_DEFINE + '02'] + this.getItem(0, 2, value)[FIELD_DEFINE + '02'] +
        this.getItem(0, 3, value)[FIELD_DEFINE + '02'] + this.getItem(0, 4, value)[FIELD_DEFINE + '02'] + this.getItem(0, 5, value)[FIELD_DEFINE + '02'] +
        this.getItem(0, 6, value)[FIELD_DEFINE + '02'] + this.getItem(0, 7, value)[FIELD_DEFINE + '02'] + this.getItem(0, 8, value)[FIELD_DEFINE + '02'] +
        this.getItem(0, 9, value)[FIELD_DEFINE + '02'] + this.getItem(0, 14, value)[FIELD_DEFINE + '02']
      if (isNaN(this.getItem(0, 15, value)[FIELD_DEFINE + '02'])) {
        this.getItem(0, 15, value)[FIELD_DEFINE + '02'] = 0
      }

      this.getItem(0, 15, value)[FIELD_DEFINE + '03'] = this.getItem(0, 1, value)[FIELD_DEFINE + '03'] + this.getItem(0, 2, value)[FIELD_DEFINE + '03'] +
        this.getItem(0, 3, value)[FIELD_DEFINE + '03'] + this.getItem(0, 4, value)[FIELD_DEFINE + '03'] + this.getItem(0, 5, value)[FIELD_DEFINE + '03'] +
        this.getItem(0, 6, value)[FIELD_DEFINE + '03'] + this.getItem(0, 7, value)[FIELD_DEFINE + '03'] + this.getItem(0, 8, value)[FIELD_DEFINE + '03'] +
        this.getItem(0, 9, value)[FIELD_DEFINE + '03'] + this.getItem(0, 14, value)[FIELD_DEFINE + '03']
      if (isNaN(this.getItem(0, 15, value)[FIELD_DEFINE + '03'])) {
        this.getItem(0, 15, value)[FIELD_DEFINE + '03'] = 0
      }

      // 固定资产账面价值=固定资产原价-减：累计折旧
      this.getItem(0, 21, value)[FIELD_DEFINE + '02'] = this.getItem(0, 19, value)[FIELD_DEFINE + '02'] - this.getItem(0, 20, value)[FIELD_DEFINE + '02']
      if (isNaN(this.getItem(0, 21, value)[FIELD_DEFINE + '02'])) {
        this.getItem(0, 21, value)[FIELD_DEFINE + '02'] = 0
      }
      this.getItem(0, 21, value)[FIELD_DEFINE + '03'] = this.getItem(0, 19, value)[FIELD_DEFINE + '03'] - this.getItem(0, 20, value)[FIELD_DEFINE + '03']
      if (isNaN(this.getItem(0, 21, value)[FIELD_DEFINE + '03'])) {
        this.getItem(0, 21, value)[FIELD_DEFINE + '03'] = 0
      }
      // 非流动资产合计
      this.getItem(0, 30, value)[FIELD_DEFINE + '02'] = this.getItem(0, 17, value)[FIELD_DEFINE + '02'] + this.getItem(0, 18, value)[FIELD_DEFINE + '02'] +
        this.getItem(0, 19, value)[FIELD_DEFINE + '02'] - this.getItem(0, 20, value)[FIELD_DEFINE + '02'] + this.getItem(0, 22, value)[FIELD_DEFINE + '02'] +
        this.getItem(0, 23, value)[FIELD_DEFINE + '02'] + this.getItem(0, 24, value)[FIELD_DEFINE + '02'] + this.getItem(0, 25, value)[FIELD_DEFINE + '02'] +
        this.getItem(0, 26, value)[FIELD_DEFINE + '02'] + this.getItem(0, 28, value)[FIELD_DEFINE + '02'] + this.getItem(0, 29, value)[FIELD_DEFINE + '02']
      if (isNaN(this.getItem(0, 30, value)[FIELD_DEFINE + '02'])) {
        this.getItem(0, 30, value)[FIELD_DEFINE + '02'] = 0
      }
      this.getItem(0, 30, value)[FIELD_DEFINE + '03'] = this.getItem(0, 17, value)[FIELD_DEFINE + '03'] + this.getItem(0, 18, value)[FIELD_DEFINE + '03'] +
        this.getItem(0, 19, value)[FIELD_DEFINE + '03'] - this.getItem(0, 20, value)[FIELD_DEFINE + '03'] + this.getItem(0, 22, value)[FIELD_DEFINE + '03'] +
        this.getItem(0, 23, value)[FIELD_DEFINE + '03'] + this.getItem(0, 24, value)[FIELD_DEFINE + '03'] + this.getItem(0, 25, value)[FIELD_DEFINE + '03'] +
        this.getItem(0, 26, value)[FIELD_DEFINE + '03'] + this.getItem(0, 28, value)[FIELD_DEFINE + '03'] + this.getItem(0, 29, value)[FIELD_DEFINE + '03']
      if (isNaN(this.getItem(0, 30, value)[FIELD_DEFINE + '03'])) {
        this.getItem(0, 30, value)[FIELD_DEFINE + '03'] = 0
      }
      // 资产总计=流动资产合计+非流动资产合计
      this.getItem(0, 31, value)[FIELD_DEFINE + '02'] = this.getItem(0, 15, value)[FIELD_DEFINE + '02'] + this.getItem(0, 30, value)[FIELD_DEFINE + '02']
      if (isNaN(this.getItem(0, 31, value)[FIELD_DEFINE + '02'])) {
        this.getItem(0, 31, value)[FIELD_DEFINE + '02'] = 0
      }
      this.getItem(0, 31, value)[FIELD_DEFINE + '03'] = this.getItem(0, 15, value)[FIELD_DEFINE + '03'] + this.getItem(0, 30, value)[FIELD_DEFINE + '03']
      if (isNaN(this.getItem(0, 31, value)[FIELD_DEFINE + '03'])) {
        this.getItem(0, 31, value)[FIELD_DEFINE + '03'] = 0
      }
      // 流动负债合计
      this.getItem(1, 11, value)[FIELD_DEFINE + '12'] = this.getItem(1, 1, value)[FIELD_DEFINE + '12'] + this.getItem(1, 2, value)[FIELD_DEFINE + '12'] +
        this.getItem(1, 3, value)[FIELD_DEFINE + '12'] + this.getItem(1, 4, value)[FIELD_DEFINE + '12'] +
        this.getItem(1, 5, value)[FIELD_DEFINE + '12'] + this.getItem(1, 6, value)[FIELD_DEFINE + '12'] +
        this.getItem(1, 7, value)[FIELD_DEFINE + '12'] + this.getItem(1, 8, value)[FIELD_DEFINE + '12'] +
        this.getItem(1, 9, value)[FIELD_DEFINE + '12'] + this.getItem(1, 10, value)[FIELD_DEFINE + '12']
      if (isNaN(this.getItem(1, 11, value)[FIELD_DEFINE + '12'])) {
        this.getItem(1, 11, value)[FIELD_DEFINE + '12'] = 0
      }
      this.getItem(1, 11, value)[FIELD_DEFINE + '13'] = this.getItem(1, 1, value)[FIELD_DEFINE + '13'] + this.getItem(1, 2, value)[FIELD_DEFINE + '13'] +
        this.getItem(1, 3, value)[FIELD_DEFINE + '13'] + this.getItem(1, 4, value)[FIELD_DEFINE + '13'] +
        this.getItem(1, 5, value)[FIELD_DEFINE + '13'] + this.getItem(1, 6, value)[FIELD_DEFINE + '13'] +
        this.getItem(1, 7, value)[FIELD_DEFINE + '13'] + this.getItem(1, 8, value)[FIELD_DEFINE + '13'] +
        this.getItem(1, 9, value)[FIELD_DEFINE + '13'] + this.getItem(1, 10, value)[FIELD_DEFINE + '13']
      if (isNaN(this.getItem(1, 11, value)[FIELD_DEFINE + '13'])) {
        this.getItem(1, 11, value)[FIELD_DEFINE + '13'] = 0
      }
      // 非流动负债合计
      this.getItem(1, 17, value)[FIELD_DEFINE + '12'] = this.getItem(1, 13, value)[FIELD_DEFINE + '12'] + this.getItem(1, 14, value)[FIELD_DEFINE + '12'] +
        this.getItem(1, 15, value)[FIELD_DEFINE + '12'] + this.getItem(1, 16, value)[FIELD_DEFINE + '12']
      if (isNaN(this.getItem(1, 17, value)[FIELD_DEFINE + '12'])) {
        this.getItem(1, 17, value)[FIELD_DEFINE + '12'] = 0
      }
      this.getItem(1, 17, value)[FIELD_DEFINE + '13'] = this.getItem(1, 13, value)[FIELD_DEFINE + '13'] + this.getItem(1, 14, value)[FIELD_DEFINE + '13'] +
        this.getItem(1, 15, value)[FIELD_DEFINE + '13'] + this.getItem(1, 16, value)[FIELD_DEFINE + '13']
      if (isNaN(this.getItem(1, 17, value)[FIELD_DEFINE + '13'])) {
        this.getItem(1, 17, value)[FIELD_DEFINE + '13'] = 0
      }
      // 负债合计
      this.getItem(1, 18, value)[FIELD_DEFINE + '12'] = this.getItem(1, 11, value)[FIELD_DEFINE + '12'] + this.getItem(1, 17, value)[FIELD_DEFINE + '12']
      if (isNaN(this.getItem(1, 18, value)[FIELD_DEFINE + '12'])) {
        this.getItem(1, 18, value)[FIELD_DEFINE + '12'] = 0
      }
      this.getItem(1, 18, value)[FIELD_DEFINE + '13'] = this.getItem(1, 11, value)[FIELD_DEFINE + '13'] + this.getItem(1, 17, value)[FIELD_DEFINE + '13']
      if (isNaN(this.getItem(1, 18, value)[FIELD_DEFINE + '13'])) {
        this.getItem(1, 18, value)[FIELD_DEFINE + '13'] = 0
      }
      // 所有者权益（或股东权益）合计
      this.getItem(1, 30, value)[FIELD_DEFINE + '12'] = this.getItem(1, 26, value)[FIELD_DEFINE + '12'] + this.getItem(1, 27, value)[FIELD_DEFINE + '12'] +
        this.getItem(1, 28, value)[FIELD_DEFINE + '12'] + this.getItem(1, 29, value)[FIELD_DEFINE + '12']
      if (isNaN(this.getItem(1, 30, value)[FIELD_DEFINE + '12'])) {
        this.getItem(1, 30, value)[FIELD_DEFINE + '12'] = 0
      }
      this.getItem(1, 30, value)[FIELD_DEFINE + '13'] = this.getItem(1, 26, value)[FIELD_DEFINE + '13'] + this.getItem(1, 27, value)[FIELD_DEFINE + '13'] +
        this.getItem(1, 28, value)[FIELD_DEFINE + '13'] + this.getItem(1, 29, value)[FIELD_DEFINE + '13']
      if (isNaN(this.getItem(1, 30, value)[FIELD_DEFINE + '13'])) {
        this.getItem(1, 30, value)[FIELD_DEFINE + '13'] = 0
      }
      // 负债和所有者权益（或股东权益）总计
      this.getItem(1, 31, value)[FIELD_DEFINE + '12'] = this.getItem(1, 18, value)[FIELD_DEFINE + '12'] + this.getItem(1, 30, value)[FIELD_DEFINE + '12']
      if (isNaN(this.getItem(1, 31, value)[FIELD_DEFINE + '12'])) {
        this.getItem(1, 31, value)[FIELD_DEFINE + '12'] = 0
      }
      this.getItem(1, 31, value)[FIELD_DEFINE + '13'] = this.getItem(1, 18, value)[FIELD_DEFINE + '13'] + this.getItem(1, 30, value)[FIELD_DEFINE + '13']
      if (isNaN(this.getItem(1, 31, value)[FIELD_DEFINE + '13'])) {
        this.getItem(1, 31, value)[FIELD_DEFINE + '13'] = 0
      }
    },
    getItem(groupNo, lineNo, value) {
      for (const item of value) {
        if (item['data' + groupNo]) {
          if (item['data' + groupNo].lineNo === lineNo &&
            item['data' + groupNo].groupNo === groupNo) {
            return item
          }
        }
      }
      return {}
    },
    exportExcelHandler(allData) {
      const columnDefs = []
      this.excelColumnDefs.forEach(column => columnDefs.push({ colDef: column }))
      let exportFileName = this.$t('CargoMsg.Cargo_BalanceSheet')
      if (this.fiscalPeriod) {
        exportFileName = this.$t('CargoMsg.Cargo_IssueOfTheYear').format(this.fiscalPeriod.year, this.fiscalPeriod.month) + exportFileName
      }
      let rows = this.rowData
      if (allData && allData.length > 0) {
        rows = allData
        exportFileName += this.$t('CargoMsg.Cargo_Details')
      }
      exportExcel(exportFileName, rows, columnDefs)
    },
    quarterLabelFun(data) {
      if (data) {
        let quarter = 1
        switch (data.month) {
          case 1:
            quarter = 1
            break
          case 4:
            quarter = 2
            break
          case 7:
            quarter = 3
            break
          case 10:
            quarter = 4
            break
          default:
            quarter = data.month
            break
        }
        return this.$t('FinanceManage.QMonthYear', [data.year, quarter])
      }
      return ''
    },
    yearLabelFun(data) {
      if (data) {
        return this.$t('FinanceManage.XYear', [data.year])
      }
      return ''
    },
    defaultFpUuid() {
      if (this.fpUuid) return
      if (this.reportType === 'quarter') {
        this.fpUuid = this.Quarters ? this.Quarters[0].uuid : ''
      } else if (this.reportType === 'year') {
        this.fpUuid = this.Years ? this.Years[0].uuid : ''
      } else {
        this.fpUuid = this.fiscalPeriods ? this.fiscalPeriods[0].uuid : ''
      }
    },
    // 导出明细
    exportHandler() {
      const tempData = [...this.rowData]
      if (!tempData || tempData.length <= 0) {
        this.$message.warning(this.$t('SeaExport.NoData'))
        return
      }
      const allData = []
      for (const item of tempData) {
        allData.push(item)
        const data0 = item.data0 || {}
        const data1 = item.data1 || {}
        const element0 = data0.elementFormula || []
        const element1 = data1.elementFormula || []
        if (element0.length > 0 || element1.length > 0) {
          if (element0.length > element1.length) {
            for (let i = 0; i < element0.length; i++) {
              const row = this.initExportRow()
              // 第一组
              const sonElement0 = element0[i]
              if (sonElement0) {
                const elementFormula = this.creatItem(sonElement0, data0.name)
                if (elementFormula && elementFormula.accountTitle) {
                  row.field00 = elementFormula.accountTitle // 资产
                  row.field01 = data0.elementNo + '-' + (i + 1) // 行次
                  row.field02 = elementFormula.beginningYear // 年初数
                  row.field03 = elementFormula.ending // 期末数
                }
              }

              // 第二组
              const sonElement1 = element1[i]
              if (sonElement1) {
                const elementFormula = this.creatItem(sonElement1, data1.name)
                if (elementFormula && elementFormula.accountTitle) {
                  row.field10 = elementFormula.accountTitle // 资产
                  row.field11 = data1.elementNo + '-' + (i + 1) // 行次
                  row.field12 = elementFormula.beginningYear // 年初数
                  row.field13 = elementFormula.ending // 期末数
                }
              }
              if (row.field00 || row.field10) {
                allData.push(row)
              }
            }
          } else {
            for (let i = 0; i < element1.length; i++) {
              const row = this.initExportRow()
              // 第二组
              const sonElement1 = element1[i]
              if (sonElement1) {
                const elementFormula = this.creatItem(sonElement1, data1.name)
                if (elementFormula && elementFormula.accountTitle) {
                  row.field10 = elementFormula.accountTitle // 资产
                  row.field11 = data1.elementNo + '-' + (i + 1) // 行次
                  row.field12 = elementFormula.beginningYear // 年初数
                  row.field13 = elementFormula.ending // 期末数
                }
              }

              // 第一组
              const sonElement0 = element0[i]
              if (sonElement0) {
                const elementFormula = this.creatItem(sonElement0, data0.name)
                if (elementFormula && elementFormula.accountTitle) {
                  row.field00 = elementFormula.accountTitle // 资产
                  row.field01 = data0.elementNo + '-' + (i + 1) // 行次
                  row.field02 = elementFormula.beginningYear // 年初数
                  row.field03 = elementFormula.ending // 期末数
                }
              }
              if (row.field00 || row.field10) {
                allData.push(row)
              }
            }
          }
        }
      }
      this.exportExcelHandler(allData)
    },
    getSpace(str) {
      const spaces = str ? str.match(/\s/g) : ''
      return spaces ? spaces.join('') : '  '
    },
    initExportRow() {
      return {
        field00: '',
        field01: '',
        field02: '',
        field03: '',
        field10: '',
        field11: '',
        field12: '',
        field13: ''
      }
    },
    getAccountTitle(accountTitle) {
      const accountTitleCollection = this.accountSet.accountTitle || []
      if (!accountTitleCollection || !accountTitle) {
        return []
      }
      return accountTitleCollection.find(title => title.accountTitle === accountTitle)
    },
    getAccountTitleBalance(accountTitle) {
      return this.atbDictionary[accountTitle]
    },
    creatItem(elementFormula, name) {
      if (!elementFormula) return
      const ac = this.getAccountTitle(elementFormula.accountTitle)
      const atb = this.getAccountTitleBalance(elementFormula.accountTitle)
      const result = {}
      result.elementDescriptionUuid = elementFormula.elementDescriptionUuid
      if (ac && atb) {
        result.accountTitle = elementFormula.accountTitle + ' ' + ac.accountTitleName
        result.beginningYear = atb.beginningBalance
        result.ending = atb.currentMonthBalanceAmount
        if (elementFormula.operateMode === 0) {
          result.beginningYear = atb.beginningBalance ? (Number(atb.beginningBalance) * -1) : atb.beginningBalance
          result.ending = atb.currentMonthBalanceAmount ? (Number(atb.currentMonthBalanceAmount) * -1) : atb.currentMonthBalanceAmount
        }
      } else {
        result.accountTitle = elementFormula.accountTitle + ' ' + (ac ? ac.accountTitleName : '')
        result.beginningYear = 0
        result.ending = 0
      }
      if (result.accountTitle) {
        const spaceStr = this.getSpace(name)
        result.accountTitle = spaceStr + '    ' + result.accountTitle
      }
      return result
    }
  }
}
</script>

<style scoped>

</style>
